import React, { useEffect, useRef } from 'react';
import Messages from './Messages';
import useStore from './store';

const MessageArea: React.FC = () => {
  const messages = useStore((s) => s.messages);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="max-w-4xl mx-auto px-6 py-6">
        <Messages messages={messages} />
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default MessageArea;
